var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagLaos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4126 9.31401C27.8246 3.96207 22.3436 0.270508 16.0003 0.270508C9.65689 0.270508 4.17589 3.96207 1.58789 9.31401L16.0003 10.7053L30.4126 9.31401Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58789 23.2272C4.17589 28.5792 9.65689 32.2708 16.0003 32.2708C22.3436 32.2708 27.8246 28.5792 30.4126 23.2272L16.0003 21.8359L1.58789 23.2272Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4124 9.31396H1.58763C0.5705 11.4174 0 13.7773 0 16.2705C0 18.7637 0.5705 21.1235 1.58763 23.227H30.4123C31.4296 21.1235 32 18.7637 32 16.2705C32 13.7773 31.4296 11.4174 30.4124 9.31396Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.8355C19.0736 21.8355 21.5652 19.3438 21.5652 16.2703C21.5652 13.1967 19.0736 10.7051 16 10.7051C12.9264 10.7051 10.4348 13.1967 10.4348 16.2703C10.4348 19.3438 12.9264 21.8355 16 21.8355Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.270508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagLaos);
export default __webpack_public_path__ + "static/media/flag_laos.8b31e61a8724750baa07d766d7b30157.svg";
export { ForwardRef as ReactComponent };